import { useState } from "react";
import { Link } from "react-router-dom";
import PartnerInventoryTrimGroup from "./PartnerInventoryTrimGroup";
import PartnerInventoryUnclassifiedBucket from "./PartnerInventoryUnclassifiedBucket";
import { formatAggregateSummary } from "../../../utils/partnerInventoryFormatters";

function NeedsReviewBadge({ count, reviewPath }) {
  if (!count) return null;
  return (
    <Link className="partner-grouped-review-badge" to={reviewPath} aria-label={`${count} listings need review`}>
      {count} need review
    </Link>
  );
}

export default function PartnerInventoryModelGroup({
  modelGroup,
  dealerId,
  path,
  reviewPath,
}) {
  const [expanded, setExpanded] = useState(false);
  const summary = formatAggregateSummary(modelGroup.aggregates);

  return (
    <div className="partner-grouped-model">
      <button
        type="button"
        className="partner-grouped-model__toggle"
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
      >
        <span className="partner-grouped-model__label">{modelGroup.model?.label || "Unknown model"}</span>
        <span className="muted partner-grouped-model__meta">
          {modelGroup.count} listing{modelGroup.count === 1 ? "" : "s"}
          {summary ? ` · ${summary}` : ""}
        </span>
      </button>
      <NeedsReviewBadge count={modelGroup.aggregates?.needsReviewCount} reviewPath={reviewPath} />

      {expanded ? (
        <div className="partner-grouped-model__body">
          {(modelGroup.trims || []).map((trimGroup, index) => (
            <PartnerInventoryTrimGroup
              key={`${trimGroup.trim?.id || trimGroup.trim?.label}-${index}`}
              trimGroup={trimGroup}
              dealerId={dealerId}
              path={path}
              reviewPath={reviewPath}
            />
          ))}
          <PartnerInventoryUnclassifiedBucket
            title="Unclassified model listings"
            count={modelGroup.unclassified?.count || 0}
            reason={modelGroup.unclassified?.reason}
            listings={modelGroup.unclassified?.listings || []}
            dealerId={dealerId}
            path={path}
            reviewPath={reviewPath}
            warningLabel="Model missing"
            showReviewLink={false}
          />
        </div>
      ) : null}
    </div>
  );
}
